import { IsIn, IsString, IsOptional, IsInt } from 'class-validator';

export class GetAbsenceScheduleQueryDto {
  @IsIn(['month', 'year'])
  @IsString()
  @IsOptional()
  calendarType? = 'month';

  @IsInt()
  @IsOptional()
  month?: number;

  @IsInt()
  @IsOptional()
  year?: number;
}
